import { i18n } from '@/plugins/i18n';

export function useI18n() {
	return i18n;
}
